export default "__VITE_ASSET__CqYUScle__"